import "./Hero.scss";

import React, { ReactNode } from "react";
import clsx from "clsx";

import HeroTitle from "../HeroTitle/HeroTitle";

export interface HeroProps {
	content?: ReactNode;
	children?: ReactNode;
	heading?: ReactNode;
	className?: string;
}

const Hero = (props: HeroProps) => {
	const { content, className, children, heading } = props;

	return (
		<div className={clsx("Hero", className)}>
			{heading && <HeroTitle>{heading}</HeroTitle>}
			{content || children}
		</div>
	);
};

export default Hero;
